import React from "react";
import styles from './site.module.scss';
import Logo from '../../logo.svg';
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Header = (props) => {
    const token = useSelector((state) => state.user.token);

    return (<>
        <header className={styles['app-header']}>
            <nav>
                <div className={styles.logo}>
                    <img src={Logo} alt='React Logo'></img>
                </div>
                <ul>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/Login">{token ? 'Account' : 'Login'}</Link></li>
                    <li><Link to="/Organization">Organization</Link></li>
                    <li><Link to="/Practitioner">Provider</Link></li>
                    <li><Link to="/docs">Docs</Link></li>
                    { token ? <li><Link to="/Person">Person</Link></li> : null}
                </ul>
                <div>
                </div>
            </nav>
        </header>
    </>);
}

export default Header;